module.exports = __webpack_public_path__ + "img/loginLogo3.29514d98.png";